/**
 * CollectionTabs - Custom Web Component dla motywu Wonder
 */
import Swiper from "./swiper-bundle.esm.browser.min.js";

if (!customElements.get('collection-tabs')) {
    class CollectionTabs extends HTMLElement {
      constructor() {
        super();
        this.tabsSwiper = null;
        this.panelsSwiper = null;
      }
  
      connectedCallback() {
        // Inicjalizacja komponentu
        this.init();
        
        // Obsługa edytora Shopify (re-inicjalizacja po zmianie ustawień)
        document.addEventListener('shopify:section:load', (e) => {
          if (e.target.contains(this)) this.init();
        });
      }
  
      init() {
        const tabsContainer = this.querySelector('.wt-collection-tabs__swiper-tabs');
        const panelsContainer = this.querySelector('.wt-collection-tabs__swiper-panels');
        const tabButtonsSpacing = parseInt(this.dataset.tabButtonsSpacing);
  
        if (!tabsContainer || !panelsContainer) return;
  
        // Zniszcz istniejące instancje, jeśli istnieją (ważne w edytorze)
        if (this.tabsSwiper) this.tabsSwiper.destroy();
        if (this.panelsSwiper) this.panelsSwiper.destroy();
  
        // 1. Inicjalizacja Slidera Tabów (Nawigacja)
        this.tabsSwiper = new Swiper(tabsContainer, {
          slidesPerView: 'auto',
          loop: false,
          watchSlidesProgress: true,
          spaceBetween: tabButtonsSpacing,
          slideToClickedSlide: true,
          centeredSlides: true,
          "breakpoints": {
            900: {
              spaceBetween: 32,
            }
          },
          on: {
            slideChange: () => {
              this.panelsSwiper.slideTo(this.tabsSwiper.activeIndex);
            }
          }
        });
  
        // 2. Inicjalizacja Slidera Paneli (Produkty)
        this.panelsSwiper = new Swiper(panelsContainer, {
          slidesPerView: 1,
          autoHeight: true, // Kluczowe: dopasowuje wysokość sekcji do ilości produktów w tabie
          spaceBetween: 20,
          speed: 400,
          grabCursor: true,
          thumbs: {
            swiper: this.tabsSwiper,
          },
          on: {
            afterInit: () => {
              // Mały hack dla poprawnego przeliczenia wysokości na starcie
              setTimeout(() => this.panelsSwiper.updateAutoHeight(), 200);
            },
            slideChange: () => {
               // Jeśli Wonder używa AOS/scroll-trigger, odświeżamy go
               this.tabsSwiper.slideTo(this.panelsSwiper.activeIndex);
               if (window.AOS) window.AOS.refresh();
            }
          }
        });
        
        // Integracja z Theme Editorem: scroll do taba po kliknięciu w blok
        this.addEventListener('shopify:block:select', (event) => {
          const index = Array.from(event.target.closest('.swiper-wrapper').children).indexOf(event.target);
          if (index !== -1) this.panelsSwiper.slideTo(index);
        });
      }
  
      disconnectedCallback() {
        if (this.tabsSwiper) this.tabsSwiper.destroy();
        if (this.panelsSwiper) this.panelsSwiper.destroy();
      }
    }
  
    customElements.define('collection-tabs', CollectionTabs);
  }